package se.mittpass.shared.repository

import io.ktor.client.*
import io.ktor.client.call.body
import io.ktor.client.request.*
import se.mittpass.shared.api.*

class TipRepository(private val httpClient: HttpClient) {
    suspend fun getTips(workplaceId: Long): Result<List<TipDto>> = runCatching {
        httpClient.get("workplaces/$workplaceId/tips").body()
    }
    suspend fun createTip(workplaceId: Long, req: CreateTipRequest): Result<Unit> = runCatching {
        httpClient.post("workplaces/$workplaceId/tips") { setBody(req) }
    }
    suspend fun deleteTip(tipId: Long): Result<Unit> = runCatching {
        httpClient.delete("tips/$tipId")
    }
}
